const actionsTypes = {
  SET_ORDERS: 'SET_ORDERS',
  SET_DELETED_ORDERS: 'SET_DELETED_ORDERS',
  SET_CURRENT_ORDER_ID: 'SET_CURRENT_ORDER_ID',
  HANDLE_MODAL_VISIBILITY: 'HANDLE_MODAL_VISIBILITY',
  HANDLE_DIALOG_VISIBILITY: 'HANDLE_DIALOG_VISIBILITY',
  SET_IS_ORDER_EDITED: 'SET_IS_ORDER_EDITED',
  SET_ANCHOR: 'SET_ANCHOR',
  SET_IMAGE_ADDRESS: 'SET_IMAGE_ADDRESS',
  SET_SELECTED_ORDERS: 'SET_SELECTED_ORDERS',
  SET_SELECTED_ITEMS: 'SET_SELECTED_ITEMS',
  SET_SLECTED_ORDERS_TO_DELETE: 'SET_SLECTED_ORDERS_TO_DELETE',
  REMOVE_SELECTED_ORDERS_TO_DELETE: 'REMOVE_SELECTED_ORDERS_TO_DELETE',
  REMOVE_SELECTED_ORDERS: 'REMOVE_SELECTED_ORDERS',
  REMOVE_SELECTED_ITEMS: 'REMOVE_SELECTED_ITEMS',
  SET_WEATHER: 'SET_WEATHER',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_ADMIN_USER: 'SET_ADMIN_USER',
};

export default actionsTypes;
